import NavBar from "../NavBar/NavBar";
import Typography from "@material-ui/core/Typography";

const NoApplication = () => (
    <>
        <NavBar />

        <Typography variant="body1" style={{ margin: "20px 10px" }}>
            Thank you for visiting our account manager. Please visit via the service you are using so that we can
            support you properly.
        </Typography>
    </>
);

export default NoApplication;
